import React, { useState } from 'react';

const Tooltip = ({ children, content, disabled = false, align = 'center' }) => {
        const [isVisible, setIsVisible] = useState(false);

        if (disabled || !content) {
                return children;
        }

        const boxAlign = align === 'right'
                ? 'right-0'
                : 'left-1/2 transform -translate-x-1/2';

        const arrowAlign = align === 'right'
                ? 'right-2'
                : 'left-1/2 transform -translate-x-1/2';

        return (
                <div
                        className="relative inline-block"
                        onMouseEnter={() => setIsVisible(true)}
                        onMouseLeave={() => setIsVisible(false)}
                >
                        {children}
                        {isVisible && (
                                <div className={`absolute z-50 bottom-full ${boxAlign} mb-2 px-3 py-2 bg-gray-900 text-white text-sm rounded-lg shadow-lg max-w-xs w-max break-words`}>
                                        <div className="relative">
                                                {content}
                                        </div>
                                        <div className={`absolute top-full ${arrowAlign} -mt-1`}>
                                                <div className="border-4 border-transparent border-t-gray-900"></div>
                                        </div>
                                </div>
                        )}
                </div>
        );
};

export default Tooltip;
